export const ASSESSOR_ASSIGNMENTS_FEATURE_KEY = 'assessorAssignments';
